import { render } from "./App.vue?vue&type=template&id=bf0d7a2c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=bf0d7a2c&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__